import Cookies from 'universal-cookie';
import * as jwt from 'jsonwebtoken';
import { JWT_COOKIE_KEY } from '../consts';
import { client } from '../apollo';
import { AuthState } from '../containers/shared/auth/AuthContext';

export const getEmptyAuthState = (): AuthState => {
  return {
    authenticated: false,
    acknowledgedDeclaration: true,
    user: {
      addOns: [],
      email: '',
      firstName: '',
      id: '',
      institution: {
        id: '',
        name: '',
        ministry: {
          id: '',
          name: '',
        },
        type: {
          id: '',
          name: '',
        },
        country: {
          id: '',
          name: '',
        },
        province: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        districtMunicipality: {
          id: '',
          name: '',
        },
        registrationOffice: [
          {
            id: '',
            name: '',
          },
        ],
      },
      lastName: '',
      permissions: [],
      plan: 'FREE_VIEWER',
      registrationRole: '',
      dataRole: '',
      roles: ['VISITOR'],
      userOrganisation: {
        id: '',
        isDefault: false,
        role: 'VISITOR',
        organisation: {
          id: '',
          name: '',
          type: '',
        },
      },
      userOrganisations: [],
    },
    accessToken: '',
    sessionId: '',
    password: '',
    defaultRedirectRoute: '',
    error: undefined,
    loading: false,
    organisationId: '',
    hasCaseManagement: false,
  };
};

export const getAuthStateFromToken = (loginToken?: string) => {
  var defaultAuthState: AuthState = getEmptyAuthState();
  const cookies = new Cookies();
  const token = loginToken || cookies.get(`${JWT_COOKIE_KEY}`);

  try {
    const verify: AuthState | undefined | null = !!token ? (jwt.decode(token) as any) : undefined;

    if (verify && verify.authenticated) {
      // get values for auth state
      defaultAuthState.authenticated = verify.authenticated;
      defaultAuthState.acknowledgedDeclaration = verify.acknowledgedDeclaration;
      defaultAuthState.user = {
        id: verify.user.id,
        email: verify.user.email,
        firstName: verify.user.firstName,
        lastName: verify.user.lastName,
        addOns: verify.user.addOns,
        institution: verify.user.institution,
        permissions: verify.user.permissions,
        plan: verify.user.plan,
        registrationRole: verify.user.registrationRole,
        dataRole: verify.user.dataRole,
        roles: verify.user.roles,
        serviceProvider: verify.user.serviceProvider,
        funder: verify.user.funder,
        userOrganisation: verify.user.userOrganisation,
        userOrganisations: [], // userOrganisations are not retrieved from token.
      };
      defaultAuthState.accessToken = verify.accessToken;
      defaultAuthState.sessionId = verify.sessionId;
      defaultAuthState.password = '';
      defaultAuthState.defaultRedirectRoute = verify.defaultRedirectRoute;
      defaultAuthState.hasCaseManagement = verify.hasCaseManagement;
      defaultAuthState.organisationId = window.location.pathname.startsWith('/admin')
        ? ''
        : defaultAuthState.user.userOrganisation.organisation.id;
    }
  } catch (err) {
    cookies.remove(`${JWT_COOKIE_KEY}`, { path: '/' });
    client.clearStore();
    defaultAuthState = getEmptyAuthState();
  }

  return defaultAuthState;
};
